import { Box } from '@wix/design-system';
import React from 'react';
import { SidePanelLayout, ToggleButton, FooterActions } from 'wix-rich-content-ui-components';
import { SETTINGS_ALLOW_DOWNALOD_TOGGLE, SETTINGS_SPOILER_TOGGLE } from '../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VideoSettings = ({
  componentData,
  t,
  settings,
  onSave,
  onCancel,
  updateData,
  shouldShowSpoiler
}) => {
  var _a, _b, _c, _d;
  const hasDisableDownload = componentData.disableDownload !== void 0 && componentData.disableDownload !== null;
  const isCustomVideo = hasDisableDownload || ((_b = (_a = componentData.video) == null ? void 0 : _a.src) == null ? void 0 : _b.id);
  const disableDownload = hasDisableDownload ? componentData.disableDownload : !!(settings == null ? void 0 : settings.disableDownload);
  const isSpoilered = (_d = (_c = componentData.containerData) == null ? void 0 : _c.spoiler) == null ? void 0 : _d.enabled;
  return /* @__PURE__ */ React.createElement(
    SidePanelLayout,
    {
      onCloseButtonClick: onCancel,
      header: { title: t("VideoPlugin_Settings_Header") },
      content: {
        children: /* @__PURE__ */ React.createElement(Box, { direction: "vertical", height: "100%", gap: "SP4" }, isCustomVideo ? /* @__PURE__ */ React.createElement(
          ToggleButton,
          {
            title: t("VideoPlugin_Settings_VideoCanBeDownloaded_Label"),
            checked: !disableDownload,
            onChange: () => updateData == null ? void 0 : updateData({ disableDownload: !disableDownload }),
            infoContent: t("VideoPlugin_Settings_VideoCanBeDownloaded_Tooltip"),
            dataHook: SETTINGS_ALLOW_DOWNALOD_TOGGLE
          }
        ) : null, shouldShowSpoiler ? /* @__PURE__ */ React.createElement(
          ToggleButton,
          {
            title: t("VideoSettings_Spoiler_Toggle"),
            checked: isSpoilered,
            onChange: () => {
              updateData == null ? void 0 : updateData({
                containerData: __spreadProps(__spreadValues({}, componentData.containerData), {
                  spoiler: { enabled: !isSpoilered }
                })
              });
            },
            infoContent: t("Spoiler_Toggle_Tooltip"),
            dataHook: SETTINGS_SPOILER_TOGGLE
          }
        ) : null)
      },
      footer: { children: /* @__PURE__ */ React.createElement(FooterActions, { onCancel, onSave }) }
    }
  );
};

export { VideoSettings };
//# sourceMappingURL=VideoSettings.js.map
